import { createAction, props } from '@ngrx/store';
import { PolicyRoutingStatistics } from '../policy-routing-statistics.model';

export const setPolicyRoutingStatisticsAction = createAction(
  '[Policy Routing Statistics] set',
  props<{ policy_routing_statistics: PolicyRoutingStatistics[] }>()
);

export const clearPolicyRoutingStatisticsAction = createAction('[Policy Routing Statistics] clear');
